import { render, staticRenderFns } from "./dialog-comfirm-updatepackage.vue?vue&type=template&id=8f50bed0&"
import script from "./dialog-comfirm-updatepackage.vue?vue&type=script&lang=js&"
export * from "./dialog-comfirm-updatepackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports